import { BatuState, BillsState, UiState, UxSurveyState } from './stateTypes';

export interface BillsInitialStates {
  normalState: BillsState;
}

export interface BatuInitialState {
  normalState: BatuState;
}
export interface UiInitialState {
  normalState: UiState;
}
export interface UxSurveyInitialState {
  normalState: UxSurveyState;
}
interface InitialStates {
  bills: BillsInitialStates;
  batu: BatuInitialState;
  ui: UiInitialState;
  uxSurvey: UxSurveyInitialState;
}

export const initialStates: InitialStates = {
  bills: {
    normalState: {
      rpu: '',
      requestedBills: [],
      massUploadFile: null,
      massUploadRPUList: [],
    },
  },
  batu: {
    normalState: {
      batu: null,
    },
  },
  ui: {
    normalState: {
      needsRegistration: false,
      needsCFECredentials: false,
      dontRemindUserCFECredentials: false,
    },
  },
  uxSurvey: {
    normalState: {
      fetchingSurvey: false,
      answeredSurvey: false,
      survey: null,
      surveyEmail: '',
      surveyChoice: 0,
      surveyFeedbackChoice: 0,
    },
  },
};
